import { convertTimeLetter } from '@helpers';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { formatHeaderDateText } from '@components/machines/components/eventsChart/helpers/formatHeaderDateText';
import { UseManageHeaderParams } from '@components/machines/components/eventsChart/types';

export const useManageHeader = ({ C, data, dataPrev, isActive, chartTitle, loading = false }: UseManageHeaderParams) => {
  const { timePeriod: selectedTime } = useHandleParams();

  const loaded = !!data?.start && !loading;
  const time = convertTimeLetter((isActive ? data?.totalActive : data?.totalProductive) as number);
  const timePrev = convertTimeLetter((isActive ? dataPrev?.totalActive : dataPrev?.totalProductive) as number);

  const dateText = formatHeaderDateText(selectedTime, data?.start, data?.end);
  const dateTextPrev = formatHeaderDateText(selectedTime, dataPrev?.start, dataPrev?.end);

  const color: Record<string, string> = {
    [MachinesScreen.ACTIVE]: C('Status/Light/Active'),
    [MachinesScreen.PRODUCTIVE]: C('Status/Light/Productive'),
  };

  const currentColor = color[chartTitle];
  const prevColor = C('Label/Light/Tertiary');
  const prevDotColor = C('Gray/Light/3');

  return {
    loaded,
    time,
    timePrev,
    dateText,
    dateTextPrev,
    currentColor,
    prevColor,
    prevDotColor,
    selectedTime,
  };
};
